import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Carousel } from 'react-bootstrap';
import { ArrowCircleLeft, ArrowCircleRightSharp } from '@mui/icons-material';
import {getGallery} from '../../api/api'
const Gallery = () => {
    const gallery = useSelector(state => state.gallery.gallery);
    console.log(gallery)
    // const fHeight = window.innerWidth > 767 ? '56vh' : '40vh';
    // const sHeight = window.innerWidth > 767 ? '55vh' : '40vh'
    // const iHeight = window.innerWidth > 767 ? '350px' : '260px' 
    let i = 0;

    useEffect(() => {
        // console.log(fHeight);
        // console.log(window.innerWidth)
        gallery.length == 0 && getGallery()
    }, [])
  return (
    // <div  className=''>
    
    <div id='gallery' className='row justify-content-center px-2'
    style={{ backgroundColor: 'whitesmoke' }}
    >
        <p className='small-header mt-2 text-center text-dark mt-5'> <u>GALLERY </u>  </p>
      <div className='col-12'> 
            <div className='row'>
            <Carousel variant='dark'
        indicators={false}
        controls = {false}
        pause={false}
        interval={2500}
            className='eventSlider col-lg-4 col-md-4 col-sm-12 col-xs-12 ps-3 gallery-container'
            style={{
              borderRadius:'2%',
                // width: '350px',
                // height: ` ${fHeight}`,
                // height: '45vh'
          }}
            >
            {
                gallery.map((img, index) => (
                
                <Carousel.Item key={index}
                className='text-center'
                variant='dark'
                style={{
                //   height:window.innerWidth > 450? 700 : 600,
                // borderRadius:'5%',
                // width: '300px',
                // height: '330px',
                // backgroundColor: 'navy',
                  
              }}
                >
                {/* <span className='col-4'> */}
                <di>
                    <img src={img.img} width={'100%'} 
                    className='gallery-image'
                    // height={`${iHeight}`} 
                      style={{ 
                        borderRadius: '2%'
                        }}
                      />
                </di>
                
                
                  
                </Carousel.Item>
                ))
            }
        
        </Carousel>

        <Carousel variant='dark'
        indicators={false}
        controls = {false}
        pause={false}
        interval={2500}
            className='eventSlider col-lg-8 col-md-8 col-sm-12 col-xs-12 pe-3 gallery-container'
            style={{
              borderRadius:'2%',
                // width: '350px',
                // height:` ${fHeight}`,
                // height: '45vh'
          }}
            >
            {
                gallery.map((img, index) => {
                  // let i = Number(index) + 1;
                  
                  if(gallery.length <= index + 3){
                    i = 0
                  }else{
                    i = index + 3
                  }
                  // if(index == 0){
                  //   i = 1
                  // }else if(index == 1){
                  //   i = 2
                  // }


                //   console.log(i);
                  return (
                
                    <Carousel.Item key={index}
                    className='text-center'
                    variant='dark'
                    style={{
                    //   height:window.innerWidth > 450? 700 : 600,
                    borderRadius:'2%',
                    // width: '300px',
                    // height: '330px',
                    // backgroundColor: 'navy',
                      
                  }}
                    >
                    {/* <span className='col-4'> */}
                    <div>
                        <img src={gallery[i].img} 
                        width={'100%'}
                        className='gallery-image'
                        // height={`${iHeight}`}
                          style={{ 
                            borderRadius: '2%'
                            }}
                          />
                      </div>
                    </Carousel.Item>
                    )
                })
            }
        
        </Carousel>
            </div>
      </div>
        <div className='col-12 '>
            <div className='row '>
                <div className='col-lg-4 col-md-4 col-sm-12 col-xs-12'>
                <Carousel variant='dark'
                indicators={false}
                controls = {false}
                pause={false}
                interval={2500}
                    className='eventSlider gallery-container2'
                    style={{
                    borderRadius:'2%',
                        width: '100%',
                        // height: `${sHeight}`,
                        // height: '40vh'
                }}
                    >
                    {
                        gallery.map((img, index) => {
                        // let i = Number(index) + 1;
                        
                        if(gallery.length <= index + 5){
                            i = 1
                        }else{
                            i = index + 5
                        }
                        // console.log(i);
                        return (
                        
                            <Carousel.Item key={index}
                            className='text-center'
                            variant='dark'
                            style={{
                            //   height:window.innerWidth > 450? 700 : 600,
                            borderRadius:'2%',
                            width: '100%',
                            // height: '90%',
                            // backgroundColor: 'navy',
                            
                        }}
                            >
                            {/* <span className='col-4'> */}
                            <div className=''>
                                <img src={gallery[i].img} width={'100%'} 
                                className='gallery-image'
                                // height={`${iHeight}`} 
                                style={{ 
                                    borderRadius: '2%'
                                    }}
                                />
                            </div>
                            </Carousel.Item>
                            )
                        })
                    }
                
                </Carousel>
                </div>
                <div className=' col-lg-4 col-md-4 col-sm-12 col-xs-12'>
                <Carousel variant='dark'
                indicators={false}
                controls = {false}
                pause={false}
                interval={2500}
                    className='eventSlider gallery-container2'
                    style={{
                    borderRadius:'2%',
                        width: '100%',
                        // height: `${sHeight}`,
                        // height: '40vh'
                }}
                    >
                    {
                        gallery.map((img, index) => {
                        // let i = Number(index) + 1;
                        
                        if(gallery.length <= index + 9){
                            i = 2
                        }else{
                            i = index + 9
                        }
                        // console.log(i);
                        return (
                        
                            <Carousel.Item key={index}
                            className='text-center'
                            variant='dark'
                            style={{
                            //   height:window.innerWidth > 450? 700 : 600,
                            borderRadius:'2%',
                            width: '100%',
                            // height: '330px',
                            // backgroundColor: 'navy',
                            
                        }}
                            >
                            {/* <span className='col-4'> */}
                            <div>
                                <img src={gallery[i].img} width={'100%'} 
                                className='gallery-image'
                                // height={`${iHeight}`} 
                                style={{ 
                                    borderRadius: '2%'
                                    }}
                                />
                            </div>
                            </Carousel.Item>
                            )
                        })
                    }
                
                </Carousel>
                </div>
                <div className=' my-1 col-lg-4 col-md-4 col-sm-12 col-xs-12 '>
                <Carousel variant='dark'
                indicators={false}
                controls = {false}
                pause={false}
                interval={2500}
                    className='eventSlider gallery-container2'
                    style={{
                    borderRadius:'2%',
                        width: '100%',
                        // height: `${sHeight}`,
                        // height: '40vh'
                }}
                    >
                    {
                        gallery.map((img, index) => {
                        // let i = Number(index) + 1;
                        
                        if(gallery.length <= index + 7){
                            i = 3
                        }else{
                            i = index + 7
                        }
                        // console.log(i);
                        return (
                        
                            <Carousel.Item key={index}
                            className='text-center'
                            variant='dark'
                            style={{
                            //   height:window.innerWidth > 450? 700 : 600,
                            borderRadius:'2%',
                            width: '100%',
                            // height: '330px',
                            // backgroundColor: 'navy',
                            
                        }}
                            >
                            {/* <span className='col-4'> */}
                            <div>
                                <img src={gallery[i].img} width={'100%'}
                                className='gallery-image'
                                // height={`${iHeight}`} 
                                style={{ 
                                    borderRadius: '2%'
                                    }}
                                />
                            </div>
                            </Carousel.Item>
                            )
                        })
                    }
                
                </Carousel>
                </div>
            </div>
        </div>



    </div>
    // </div>
  )
}

export default Gallery